import React from 'react';
import UploadIcon from '@atlaskit/icon/core/migration/cloud-arrow-up--upload';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useRouteByName } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import messages from './messages.tsx';

type Props = {
	projectKey: string;
	testId: string;
};

export const DeploymentsMenuItem = ({ projectKey, testId }: Props) => {
	const { formatMessage } = useIntl();
	const deploymentsRoute = useRouteByName('software-deployments-classic');

	// The route definition will be null when this component is rendered outside
	// of the SPA (e.g. the settings page in Classic projects)
	const menuItemProps =
		deploymentsRoute !== null
			? {
					to: deploymentsRoute,
					params: { projectKey },
				}
			: {
					href: `/jira/software/c/projects/${projectKey}/deployments`,
				};

	return (
		<MenuItem
			{...menuItemProps}
			analytics={{
				itemId: 'deployments',
			}}
			selectedOn={['software-deployments-classic']}
			iconBefore={<UploadIcon spacing="spacious" label="" />}
			testId={testId}
		>
			{formatMessage(messages.deploymentsItem)}
		</MenuItem>
	);
};
